import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';

// 액션 타입을 정의해줍니다.
const UPDATED_COMMENT_ITEM = 'chatAction/updatedCommentItemState';
const DELETED_COMMENT_ITEM = 'chatAction/deletedCommentItemState';

// 액션 생성 함수를 만듭니다.
export const updatedComment = createAction(UPDATED_COMMENT_ITEM);
export const deletedComment = createAction(DELETED_COMMENT_ITEM);

// 모듈의 초기 상태를 정의합니다.
const initialState = {
  updatedComment:null,
  deletedComment:null
};


// immer 를 사용하여 값을 수정하는 리듀서입니다.
export default handleActions({
  [UPDATED_COMMENT_ITEM]: (state, action) => {
    return produce(state, draft => {
      draft.updatedComment = action.payload.updatedComment;
    });
  },
  [DELETED_COMMENT_ITEM]: (state, action) => {
    return produce(state, draft => {
      draft.deletedComment = action.payload.deletedComment;
    });
  },
}, initialState);